import { Link } from 'react-router-dom'
import { SupportContact } from '../components/SupportContact.js'

/**
 * アカウント凍結中画面。
 *
 * - 「凍結されています」を明示
 * - データは保持されている旨
 * - 有料プラン申込み導線（運営問い合わせ）
 *
 * 関連: docs/business-requirements.md §6.C
 */
export function AccountFrozenPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-bold text-yellow-900">アカウントがお休み状態になりました</h1>
        <p className="text-sm text-muted-foreground">
          60日以上ログインがなかったため、無料プランの仕様でアカウントが自動でお休み状態になりました。
        </p>
        <div className="bg-blue-50 border border-blue-200 rounded-md p-3 text-left">
          <p className="text-sm font-medium text-blue-900">データは保持されています</p>
          <p className="text-xs text-blue-900 mt-1">
            プロジェクト・ファイル・共有URL はすべて削除されずに残っています。
            再開すれば即座に元の状態で使えます。
          </p>
        </div>
        <div className="space-y-2">
          <p className="text-sm">再開には有料プラン申込みが必要です。</p>
          <SupportContact
            subject="有料プラン申込み"
            label="運営に問い合わせる"
            className="inline-block px-6 py-3 bg-primary text-primary-foreground rounded-md font-medium"
          />
        </div>
        <Link to="/login" className="block text-xs text-muted-foreground hover:underline">
          別アカウントでログインする
        </Link>
      </div>
    </div>
  )
}
